module.exports = __webpack_public_path__ + "static/media/yjsuan.cc15d8a9.png";